import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'mailto',
  pure: true,
  standalone: true,
})
export class MailtoPipe implements PipeTransform {
  public transform(value: string): string {
    if (value == null) return null;
    if (typeof value !== 'string') {
      if (!environment.production) {
        throw Error('InvalidPipeArgument: ' + value);
      }
      return null;
    }
    const email = value.trim();
    if (!email) return null;
    return `<a class="underline hover:no-underline" href="mailto:${email}">${email}</a>`;
  }
}
